export default {
    parts: ['drawerContent', 'closeButton', 'drawerBody', 'spinner'],
    baseStyle: {
        drawerContent: {
            maxW: {md: '483px'},
            maxH: {base: '85%', md: '100%'}
        },
        closeButton: {
            position: 'absolute',
            w: {base: '24px'},
            h: {base: '24px'},
            top: {base: '12px', lg: '24px'},
            right: {base: '0', lg: '16px'},
            zIndex: '2',
            backgroundColor: 'transparent',
            _hover: {backgroundColor: 'transparent'},
            color: 'black'
        },
        drawerBody: {
            padding: {base: '22px 16px', lg: 6}
        },
        spinner: {
            size: 'lg',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
        }
    }
}
